// components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ permissions, formName, children }) => {
  const hasPermission = permissions?.find(
    (perm) => perm.formName === formName && perm.canView
  );
  
  return hasPermission ? children : <Navigate to="/no-access" replace />;
};

export default ProtectedRoute;
